module.exports = __webpack_public_path__ + "static/media/mail-header.00b08fe0.svg";